<script setup>
import {onBeforeMount, reactive, ref} from 'vue'
import {onBeforeRouteLeave} from 'vue-router'
import {can, clone} from '@/paks/vu-app'
import ActionEdit from './ActionEdit.vue'

const props = defineProps({
    modelValue: Object,
    board: Object,
    parent: Object,
})

const page = reactive({
    action: null,
    actions: null,
    drag: null,
    showEdit: false,
    widget: null,
})

const emit = defineEmits(['update:modelValue'])
const edit = ref(null)

const Fields = [
    {
        name: 'drag',
        title: 'Order',
        icon: (v, rec) => (rec.path != '/' ? '$drag' : ''),
        cursor: (v, rec) => (rec.path != '/' ? 'grab' : 'default'),
        width: '5%',
    },
    {name: 'edit', icon: '$edit', width: '2%'},
    {name: 'type', width: '30%'},
    {name: 'target', width: '30%'},
    {name: 'conditions', format: (v) => v.length},
]

onBeforeMount(() => {
    let widget = (page.widget = clone(props.modelValue))
    widget.actions = widget.actions || []
    indexActions(widget)
    page.drag = {
        vertical: {dir: 'vertical', move: true, removeOnSpill: false},
    }
})

function indexActions(widget) {
    let index = 0
    for (let action of widget.actions) {
        action._index = index++
    }
}

onBeforeRouteLeave(() => closeEditAsk(true))

async function clicked({action: cmd, item, items, column}) {
    if (!can('admin')) {
        return
    }
    if (cmd == 'add') {
        editAction({})
    } else if (cmd == 'delete') {
        removeActions(items)
    } else if (cmd == 'edit') {
        editAction(item)
    } else if (cmd == 'cell') {
        editAction(item)
    }
}

function removeActions(items) {
    for (let item of items) {
        page.widget.actions.splice(item._index, 1)
    }
    indexActions(page.widget)
    // FORCE table update
    // page.widget.actions = page.widget.actions.slice(0)
    emit('update:modelValue', page.widget)
}

function removeAction(action) {
    page.widget.actions.splice(action._index, 1)
    indexActions(page.widget)
    // FORCE table update
    // page.widget.actions = page.widget.actions.slice(0)
    page.action = null
    emit('update:modelValue', page.widget)
}

async function editAction(action) {
    if (action) {
        if (action._index == null) {
            action._index = page.widget.actions.length
        }
        page.showEdit = true
        page.action = action
    } else {
        page.showEdit = false
        if (page.action) {
            page.widget.actions.splice(page.action._index, 1, page.action)
            // FORCE table update
            // page.widget.actions = page.widget.actions.slice(0)
            emit('update:modelValue', page.widget)
        }
    }
    window.scrollTo({top: 0, behavior: 'smooth'})
}

function closeEditAction() {
    page.showEdit = false
}

async function closeEditAsk(discard) {
    let action = edit.value?.page?.action
    if (!action) {
        return true
    }
    if ((discard && action.type) || action.type == null) {
        // TODO page.changed not yet implemented
        if (edit.value.page.changed) {
            if (await confirm.value.ask(`Do you want to discard changes? `)) {
                return true
            }
            return false
        }
        return true
    }
    return true
}

async function dragged(event) {
    let {type, index, targetIndex} = event.detail
    if (type == 'drop') {
        let actions = page.widget.actions
        actions.splice(targetIndex - 0, 0, ...actions.splice(index - 0, 1))
        emit('update:modelValue', page.widget)
    }
}
</script>

<template>
    <vu-table
        class="widget-actions"
        name="Actions"
        nodata="No Items"
        options="dynamic,toolbar"
        ref="table"
        row-key="type"
        title="Widget Actions"
        width="100%"
        :drag="page.drag"
        :data="page.widget.actions"
        :fields="Fields"
        :select="{actions: {Add: 0, Edit: 1, Delete: 2}, multi: true}"
        @drag="dragged"
        @click="clicked">
        <template v-slot:more="props">
            <v-btn color="primary" class="mr-2 add" @click="editAction({})">Add Action</v-btn>
        </template>
    </vu-table>

    <vu-panel
        v-if="page.showEdit"
        class="actions-panel"
        v-model="page.showEdit"
        :_confirm="closeEditAsk"
        :keyboard="false"
        :nested="true"
        :widths="['530px']"
        @close="closeEditAction">
        <ActionEdit
            v-model="page.action"
            ref="edit"
            :widget="page.widget"
            @close="editAction"
            @remove="removeAction" />
    </vu-panel>
</template>

<style lang="scss">
.actions-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    z-index: 99999;
}
</style>
